import { RowAction } from './../../../shared/base-reporting/models/row-actions.interface';
import { RowActionCallback } from './../../../shared/base-reporting/models/row-action-callback.interface';
import { FilterItem } from './../../../shared/base-reporting/models/filter-item.interface';
import { FilterCallback } from './../../../shared/base-reporting/models/filter-callback.interface';
import { Inquiry } from './../../../shared/models/inquiry.model';
import { InquiryService } from './../../services/inquiry.service';
import { Router } from '@angular/router';
import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import * as moment from 'moment';

@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.css']
})
export class ListComponent implements OnInit {

  get data(): Array<TableViewItem> {
    return this.Data
      .filter(row => {
        if (this.currentFilterObject.fullName) {
          return row.fullName.toLowerCase().includes(this.currentFilterObject.fullName.toLowerCase());
        }
        return true;
      })
      .filter(row => {

        if (this.currentFilterObject.type) {
          return this.currentFilterObject.type.includes(
            row.type
          );
        }
        return true;
      }).filter(row => {

        if (this.currentFilterObject.status) {
          return this.currentFilterObject.status.includes(
            row.status
          );
        }
        return true;
      }).filter(row => {
        if (
          this.currentFilterObject.arrivalDate &&
          this.currentFilterObject.arrivalDate.startDate &&
          this.currentFilterObject.arrivalDate.endDate
        ) {
          return moment(row.arrivalDate).isBetween(
            // @ts-ignore
            this.currentFilterObject.arrivalDate.startDate._i,
            // @ts-ignore
            this.currentFilterObject.arrivalDate.endDate._i
          );
        } else {
          return true;
        }
      }).filter(row => {
        if (
          this.currentFilterObject.departureDate &&
          this.currentFilterObject.departureDate.startDate &&
          this.currentFilterObject.departureDate.endDate
        ) {
          return moment(row.departureDate).isBetween(
            // @ts-ignore
            this.currentFilterObject.departureDate.startDate._i,
            // @ts-ignore
            this.currentFilterObject.departureDate.endDate._i
          );
        } else {
          return true;
        }
      }).filter(row => {
        if (this.currentFilterObject.numberOfAdults) {
          return row.numberOfAdults === this.currentFilterObject.numberOfAdults;
        }
        return true;
      });
  }


  set data(v: Array<TableViewItem>) {
    this.Data = v;
  }

  constructor(private inquiryService: InquiryService, private router: Router) { }
  inquiry = new Inquiry();
  viewFlag = false;
  @ViewChild('viewInquiry', { static: true }) viewInquiry: ElementRef;
  private Data = [] as Array<TableViewItem>;
  tableColumns = [
    'fullName',
    'numberOfAdults',
    'numberOfChilds',
    'type',
    'form',
    'status',
    'arrivalDate',
    'departureDate',
  ];
  currentFilterObject = {} as FilterModel;


  rowActions: Array<RowAction> = [
    {
      type: 'icon',
      slug: 'viewInquiry',
      class: 'btn',
      iconClasses: 'fa fa-eye',
      onClick: this.updateViewFlag()
    }
  ];

  reportFilter: Array<FilterItem> = [
    {
      fieldName: 'fullName',
      fieldDisplayName: 'Full Name',
      fieldType: 'text'
    },
    {
      fieldName: 'arrivalDate',
      fieldDisplayName: 'Arrival Date ',
      fieldType: 'daterange'
    },
    {
      fieldName: 'departureDate',
      fieldDisplayName: 'Departure Date ',
      fieldType: 'daterange'
    },
    {
      fieldName: 'type',
      fieldDisplayName: 'Inquiry Type ',
      fieldType: 'select',
      multiple: false,
      hasSelectAll: false,
      defaultValue: null,
      options: [
        { value: null, display: 'Choose Type' },
        { value: 'Regular', display: 'Regular' },
        { value: 'GroupOffer', display: 'Group Offer' },
        { value: 'Book', display: 'Book' }
      ]
    },
    {
      fieldName: 'status',
      fieldDisplayName: 'Inquiry Status ',
      fieldType: 'select',
      multiple: false,
      hasSelectAll: false,
      defaultValue: null,
      options: [
        { value: null, display: 'Choose Type' },
        { value: 'NEW', display: 'New' },
        { value: 'CLOSED_CONFIRMED', display: 'Closed Confirmed' },
        { value: 'CLOSED_LOST', display: 'Closed Lost' },
        { value: 'PENDING_CUSTOMER_REPLY', display: 'Pending Customer Reply' },
        { value: 'PENDING_CS_REPLY', display: 'Pending CS Reply' },
        { value: 'NON_SALES_INQUIRY', display: 'Non Sales Inquiry' }
      ]
    },
    {
      fieldName: 'numberOfAdults',
      fieldDisplayName: 'Number Of Adults ',
      fieldType: 'number'
    },
    {
      fieldName: 'numberOfChilds',
      fieldDisplayName: 'Number Of Childs ',
      fieldType: 'number'
    }
  ];

  ngOnInit() {
    this.fetchData();
  }
  onFilter(event: FilterCallback) {
    this.currentFilterObject = event.filter;
  }

  fetchData() {
    this.inquiryService.getAllInquiries().subscribe(response => {

      this.Data = response.data.inquiries.map(r => {

        if (r.message == null) {
          r.message = '-';
        }

        return {
          id: r.id,
          fullName: r.fullName,
          numberOfAdults: r.numberOfAdults,
          numberOfChilds: r.numberOfChilds,
          type: this.transform(r.type),
          form: this.transform(r.form),
          status: this.transform(r.status),
          arrivalDate: r.arrivalDate,
          departureDate: r.departureDate,
        } as TableViewItem;
      });
    });
  }
  updateViewFlag () {
    this.viewFlag = true;
  }
  rowActionCB(event: RowActionCallback) {
    switch (event.action) {
      case 'viewInquiry':
        this.viewInquiry.nativeElement.click();
        this.viewFlag = true;
        this.inquiry = event.on;
        break;
      default:
        console.error('this is a mistake!');
    }
  }

  fetchTable(event) {
    if (event[`flag`] === true) {
      this.fetchData();
    }
  }

  transform(input: string) {
    return input.toLowerCase().replace(/_/g, ' ');
  }
}


interface FilterModel {
  fullName: string;
  arrivalDate: DateRangeModel;
  departureDate: DateRangeModel;
  numberOfAdults: number;
  numberOfChilds: number;
  type: string;
  status: string;
}

interface TableViewItem {
  id: number;
  fullName: string;
  numberOfAdults: number;
  numberOfChilds: number;
  type: string;
  form: string;
  status: string;
  arrivalDate: string;
  departureDate: string;
}

interface DateRangeModel {
  startDate?: moment.Moment;
  endDate?: moment.Moment;
}
